import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
// import { identicon } from 'identicon';
// import { fs } from 'fs'
import { MatDialog, MatDialogConfig } from '@angular/material/';
import { ModalComponent } from '../modal/modal.component';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(dialog, router, helper) {
        this.dialog = dialog;
        this.router = router;
        this.helper = helper;
        this.show = false;
        this.address = this.helper.accountList[this.helper.slectedAddress];
        this.modifiedAddress = this.address.substring(0, 6) + "..." + this.address.substr(this.address.length - 4);
        this.balance = this.helper.accountListBalance[this.address];
        this.symbol = this.helper.currentAccount.symbol;
    }
    DashboardComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.helper.checkBalance()];
                    case 1:
                        _a.balance = _b.sent();
                        console.log(this.balance);
                        this.helper.selAcc.subscribe(function (x) {
                            console.log(_this.helper.accountListBalance);
                            _this.address = _this.helper.accountList[_this.helper.slectedAddress];
                            _this.modifiedAddress = _this.address.substring(0, 6) + "..." + _this.address.substr(_this.address.length - 4);
                            _this.balance = _this.helper.accountListBalance[_this.address];
                            _this.symbol = _this.helper.currentAccount.symbol;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardComponent.prototype.route = function (linkName) {
        var link = ['/' + linkName];
        this.router.navigate(link);
    };
    // txHistory() {
    //   this.router.navigate(['txhistory'])
    // }
    DashboardComponent.prototype.openDialog = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            id: 1,
            title: 'Angular For Beginners'
        };
        dialogConfig.minWidth = '300px';
        // this.dialog.dialogContainer = {
        // }
        dialogConfig.position = {
            top: '67px',
            right: '0',
        };
        this.dialog.open(ModalComponent, dialogConfig);
    };
    DashboardComponent.prototype.showHide = function () {
        this.show = !this.show;
    };
    return DashboardComponent;
}());
export { DashboardComponent };
